import script from "./electricityUsageRecord.vue?vue&type=script&setup=true&lang=js"
export * from "./electricityUsageRecord.vue?vue&type=script&setup=true&lang=js"

import "./electricityUsageRecord.vue?vue&type=style&index=0&id=1d3e100f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d3e100f"]])

export default __exports__